import {FocusManagerContext, VerticalList} from 'focus-manager/web';
import * as React from 'react';

import IFormValue from '../Interfaces/IFormValue';
import FormState from '../Models/FormState';
import createNextValue from '../Util/createNextValue';

import Footer from './Footer';
import FormFields from './FormFields';
import FormNavigator from './FormNavigator';
import Keyboard from './Keyboard';

const SignInForm: React.FC = () => {
    const [formState, setFormState] = React.useState(new FormState());
    const [formValue, setFormValue] = React.useState<IFormValue>({username: '', password: ''});
    const focusManager = React.useContext(FocusManagerContext);

    const handlePrevSelect = React.useCallback(() => {
        setFormState(({prevIndex}) => new FormState(prevIndex));

        // Return focus to first key of keyboard, when the previous
        // button becomes disabled

        if (!formState.canGoBack) focusManager.focus('KEYBOARD', [0]);
    }, []);

    const handleNextSelect = React.useCallback(() => {
        if (formState.canSubmit) console.info('submit!', formValue);
        else setFormState(({nextIndex}) => new FormState(nextIndex));
    }, [formState, formValue]);

    const handleKeySelect = React.useCallback(
        (keyValue: string) =>
            setFormValue(({username, password}) => ({
                username: formState.isUsernameActive ? createNextValue(username, keyValue) : username,
                password: formState.isPasswordActive ? createNextValue(password, keyValue) : password,
            })),
        [formState]
    );

    return (
        <form className="sign-in-form">
            <VerticalList className="form-keys" justify loop>
                <Keyboard onKeySelect={handleKeySelect} />
                <FormNavigator formState={formState} onNextSelect={handleNextSelect} onPrevSelect={handlePrevSelect} />
                <Footer />
            </VerticalList>
            <FormFields formState={formState} formValue={formValue} />
        </form>
    );
};

export default SignInForm;
